import { CheckOutlined, DeleteOutlined, DownloadOutlined, InfoCircleFilled } from '@ant-design/icons';
import {
    Button,
    Col,
    Modal,
    notification,
    Popconfirm,
    Progress,
    Row,
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import pound from 'shared/assets/icons/pound.svg';
import { FINALIZEFINANCIAL, FINANCIALS, TECHNICALS } from 'shared/constants/RouteConstants';
import { commaAddingInPrice } from 'shared/services/Utility';
import AccessControl from '../../../services/AccessControl';
import API_SERVICE from '../../../services/api-service';
import './index.scss';
import ProjectCreateOrEditPage from '../Technical/ProjectCreateOrEditPage';
import { Edit } from '@material-ui/icons';
import { Box } from '@material-ui/core';
import { ConfirmationModal } from 'components';

export default function ClaimOverviewPage(props: any) {
    const [currentStage, setCurrentStage] = useState(0);
    const [claimStages, setClaimStages] = useState([] as any);
    const [addNew, setAddNew] = useState(false);
    const [editProject, setEditProject] = useState(null);
    const [projects, setProjects] = useState([] as any);
    const [confirmationModal, setConfirmationModal] = useState({} as any);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [financialDowloading, setFinancialDowloading] = useState(false);


    const projectInfoModalContent = (ok:boolean)=> ({
        title: 'Projects Information',
        content: (
            <div>
                <ul style={{ paddingLeft: '20px', marginBottom: 0 }}>
                    <li style={{ marginBottom: '8px' }}>For 1 to 3 projects the company will need to describe all projects, covering 100% of the qualifying expenditure</li>
                    <li style={{ marginBottom: '8px' }}>For 4 to 10 projects it will need to describe projects that account for 50% of the total expenditure, with a minimum of 3 projects described</li>
                    <li>For 10 to 100 plus projects, it will need to describe projects that account for 50% of the total expenditure, with a minimum of 3 projects described - however, if the qualifying expenditure is split across multiple smaller projects, describe the 10 largest</li>
                </ul>
            </div>
        ),
        onOk() {
            Boolean(ok) && setAddNew(true);
         },
    })

    const [details, setDetails] = useState({
        id: null,
        company: { name: '' },
        manager: {
            user: { name: '' },
        },
        type: {
            displayName: '',
        },
        inProgressFinancial: 0,
        inProgressTechnical: 0,
        financialYear: 0,
        value: 0,
        claimStartDate: '',
        claimEndDate: '',
        deadlineInternal: '',
        deadlineExternal: '',
        claimDate: '',
        isProjectLinked: 0,
    });
    const [allProgress, setAllProgress] = useState({
        financial: 0,
        technical: 0,
        amendment: 0,
        submitted: 0,
    });

    const getClaimStages = async () => {
        try {
            const {
                data: { data },
            } = await API_SERVICE.getClaimStages();
            setClaimStages(data.items.sort((a: any, b: any) => a.id - b.id));
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
    };

    const setProgressBarValue = () => {
        //@ts-ignore
        let currentStage = details && details.stage && details.stage.id;
        if (currentStage === 1) {
            if (
                details.inProgressFinancial === 1 &&
                details.inProgressTechnical === 0
            ) {
                setAllProgress({
                    financial: 50,
                    technical: 0,
                    amendment: 0,
                    submitted: 0,
                });
            }
            if (
                details.inProgressFinancial === 0 &&
                details.inProgressTechnical === 1
            ) {
                setAllProgress({
                    technical: 50,
                    financial: 0,
                    amendment: 0,
                    submitted: 0,
                });
            }
            if (
                details.inProgressFinancial === 1 &&
                details.inProgressTechnical === 1
            ) {
                setAllProgress({
                    technical: 50,
                    financial: 50,
                    amendment: 0,
                    submitted: 0,
                });
            }
        }
        if (currentStage === 2) {
            if (
                details.inProgressFinancial === 1 &&
                details.inProgressTechnical === 0
            ) {
                setAllProgress({
                    financial: 100,
                    technical: 0,
                    amendment: 0,
                    submitted: 0,
                });
            }

            if (
                details.inProgressFinancial === 1 &&
                details.inProgressTechnical === 1
            ) {
                setAllProgress({
                    financial: 100,
                    technical: 50,
                    amendment: 0,
                    submitted: 0,
                });
            }
        }

        if (currentStage === 3) {
            if (
                details.inProgressFinancial === 0 &&
                details.inProgressTechnical === 1
            ) {
                setAllProgress({
                    financial: 0,
                    technical: 100,
                    amendment: 0,
                    submitted: 0,
                });
            }
            if (
                details.inProgressFinancial === 1 &&
                details.inProgressTechnical === 1
            ) {
                setAllProgress({
                    financial: 100,
                    technical: 100,
                    amendment: 0,
                    submitted: 0,
                });
            }
        }
        if (currentStage === 4) {
            setAllProgress({
                financial: 100,
                technical: 100,
                amendment: 100,
                submitted: 0,
            });
        }

        if (currentStage === 5) {
            setAllProgress({
                financial: 100,
                technical: 100,
                amendment: 100,
                submitted: 100,
            });
        }
    };

    const refresh = async () => {
        const {
            match: { params },
        } = props;
        try {
            const {
                data: { data },
            } = await API_SERVICE.getClaimById(params.claimId);
            setDetails(data);
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
    };

    const getProjects = async () => {
        const {
            match: { params },
        } = props;
        try {
            const {
                data: { data },
            } = await API_SERVICE.getProjects(params.claimId);
            setProjects(data.items);
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
    };

    useEffect(() => {
        refresh();
        getClaimStages();
        getProjects();
    }, []);

    useEffect(() => {
        //@ts-ignore
        details && details.stage && setCurrentStage(details.stage.id);
        setProgressBarValue();
    }, [details]);

    const finalizeTechnicalStage = async () => {
        try {
            const {
                match: { params },
            } = props;
            await API_SERVICE.finalizeTechnicals(params.claimId);
            refresh();
            notification.success({
                message: 'Technical Data successfully Finalised',
            });
        } catch (error) {
            notification.error({
                message: API_SERVICE.handleErrors(error),
            });
        }
    };

    const finalizeFinalStage = async () => {
        try {
            const {
                match: { params },
            } = props;
            await API_SERVICE.finalizeFinalStage(params.claimId);
            notification.success({
                message: 'Claim successfully Finalised',
            });
            refresh();
        } catch (error) {
            notification.error({ message: API_SERVICE.handleErrors(error) });
        }
    };

    const handleDownload = async () => {
        setFinancialDowloading(true);
        const {
            match: { params },
        } = props;
        try {
            const {
                data: { data },
            } = await API_SERVICE.downloadFinancialReport(params.claimId);
            window.open(API_SERVICE.downloadReport(data.url));
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        } finally{
            setFinancialDowloading(false);
        }
    };

    const handleDownloadTechnicalReport = async () => {
        setLoadingDownload(true);
        const {
            match: { params },
        } = props;
        try {
            const {
                data: { data },
            } = await API_SERVICE.downloadTechnicialReport(params.claimId);
            const a = document.createElement('a');
            a.href = data.filePath;
            a.download = 'TechnicalReport';
            a.click();
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }finally{
            setLoadingDownload(false);
        }
    };

    return (
        <div className={'claim-overview-wrapper page-wrapper'}>
            <div>
                <Row justify={'center'}>
                    <Col xs={20}>
                        <h1 className="text-center page-title">
                            Overview | Claim ID: {details.id}
                        </h1>

                        <Row>
                            <Col
                                className="overview-detail-table-column"
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                            >
                                <div className="d-flex align-items-center h-100">
                                    <table className="overview-detail-table">
                                        <tr>
                                            <th>Company Name:</th>
                                            <td>{details?.company?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Claim Tax Year:</th>
                                            <td>
                                                {details?.financialYear} -{' '}
                                                {details?.financialYear + 1}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Manager Name:</th>
                                            <td>
                                                {details?.manager?.user?.name}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Col>
                            <Col
                                className="overview-detail-table-column"
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                            >
                                <div className="d-flex align-items-center h-100">
                                    <table className="overview-detail-table">
                                        <tr>
                                            <th>Claim Type:</th>
                                            <td>
                                                {details?.type?.displayName}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Claim Value:</th>
                                            <td>
                                                {commaAddingInPrice(
                                                    details?.value,
                                                )}{' '}
                                                GBP
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Col>
                            <Col
                                className="overview-detail-table-column"
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                            >
                                <div className="d-flex align-items-center h-100">
                                    <table className="overview-detail-table">
                                        <tr>
                                            <th>Start Date:</th>
                                            <td>
                                                {moment(
                                                    details.claimStartDate,
                                                ).format('DD/MM/YYYY')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>End Date:</th>
                                            <td>
                                                {moment(
                                                    details.claimEndDate,
                                                ).format('DD/MM/YYYY')}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Col>
                            <Col
                                className="overview-detail-table-column"
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                            >
                                <div className="d-flex align-items-center h-100">
                                    <table className="overview-detail-table">
                                        <tr>
                                            <th>Internal Deadline:</th>
                                            <td>
                                                {moment(
                                                    details.deadlineInternal,
                                                ).format('DD/MM/YYYY')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>External Deadline:</th>
                                            <td>
                                                {moment(
                                                    details.deadlineExternal,
                                                ).format('DD/MM/YYYY')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Claim Date:</th>
                                            <td>
                                                {details.claimDate
                                                    ? moment(
                                                        details.claimDate,
                                                    ).format('DD/MM/YYYY')
                                                    : 'N/A'}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                        <Row
                            justify="center"
                            align="middle"
                            className="rowGap"
                            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                        >
                            <Col xs={24} sm={24} md={6} lg={5}>
                                <div
                                    className={'d-flex justify-content-between'}
                                    style={{
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Progress
                                        strokeColor={{
                                            '0%': '#108ee9',
                                            '100%': '#87d068',
                                        }}
                                        percent={100}
                                        showInfo={false}
                                    />

                                    <span
                                        className={`steps move-left ${currentStage === 1 ? 'active' : ''
                                            }`}
                                    >
                                        {claimStages[0]?.id === 1 &&
                                            claimStages[0]?.displayName}
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={6} lg={5}>
                                <Row>
                                    <Col xs={24}>
                                        <div
                                            className={
                                                'd-flex justify-content-between'
                                            }
                                            style={{
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Progress
                                                strokeColor={{
                                                    '0%': '#108ee9',
                                                    '100%': '#87d068',
                                                }}
                                                percent={allProgress.financial}
                                                showInfo={false}
                                            />

                                            <span
                                                className={`steps move-left ${currentStage === 2
                                                        ? 'active'
                                                        : ''
                                                    }`}
                                            >
                                                {claimStages[1]?.id === 2 &&
                                                    claimStages[1]?.displayName}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col xs={24}>
                                        <div
                                            className={
                                                'd-flex justify-content-between'
                                            }
                                            style={{
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Progress
                                                strokeColor={{
                                                    '0%': '#108ee9',
                                                    '100%': '#87d068',
                                                }}
                                                percent={allProgress.technical}
                                                showInfo={false}
                                            />

                                            <span
                                                className={`steps move-left ${currentStage === 3
                                                        ? 'active'
                                                        : ''
                                                    }`}
                                            >
                                                {claimStages[2]?.id === 3 &&
                                                    claimStages[2]?.displayName}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} sm={24} md={6} lg={5}>
                                <div
                                    className={'d-flex justify-content-between'}
                                    style={{
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Progress
                                        strokeColor={{
                                            '0%': '#108ee9',
                                            '100%': '#87d068',
                                        }}
                                        percent={allProgress.amendment}
                                        showInfo={false}
                                    />

                                    <span
                                        className={`steps move-left ${currentStage === 4 ? 'active' : ''
                                            }`}
                                    >
                                        {claimStages[3]?.id === 4 &&
                                            claimStages[3]?.displayName}
                                    </span>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={6} lg={5}>
                                <div
                                    className={'d-flex justify-content-between'}
                                    style={{
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Progress
                                        strokeColor={{
                                            '0%': '#108ee9',
                                            '100%': '#87d068',
                                        }}
                                        percent={allProgress.submitted}
                                        showInfo={false}
                                    />

                                    <span
                                        className={`steps move-left ${currentStage === 5 ? 'active' : ''
                                            }`}
                                    >
                                        {' '}
                                        {claimStages[4]?.id === 5 &&
                                            claimStages[4]?.displayName}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                        <Row justify={'center'} className="my-5" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col xs={24} sm={24} md={24} lg={24}>
                                <Box className="project-management-container" style={{
                                    border: '1px solid #e8e8e8',
                                    borderRadius: '6px',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.03)',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <div className="flex justify-between" style={{
                                        padding: '5px 12px',
                                        borderBottom: '1px solid #d9d9d9',
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                        <h2 className="text-lg font-bold" style={{
                                            flex: 1,
                                            margin: 0,
                                        }}>Manage Projects
                                            <InfoCircleFilled onClick={() => {
                                                Modal.info(projectInfoModalContent(false));
                                            }} style={{ color: '#000', marginLeft: '8px', cursor: 'pointer' }} />
                                        </h2>

                                        <Button
                                            type="primary"
                                            size="small"
                                            shape="round"
                                            className="theme-button primary"
                                            onClick={() => {
                                                projects.length ===0  ?
                                                Modal.info(projectInfoModalContent(true))
                                                : setAddNew(true)
                                            }}
                                        >
                                            Add Project
                                        </Button>

                                    </div>
                                    {projects.length === 0 ? (
                                        <div style={{ padding: '15px', textAlign: 'center', color: '#999' }}>
                                            No projects added yet. Click "Add Project" to create one.
                                        </div>
                                    ) : (
                                        <div style={{ padding: '6px' }}>
                                            <Row gutter={[8, 8]}>
                                                {projects.map((project: any, index: number) => (
                                                    <Col key={project.id} xs={24} sm={24} md={projects.length > 3 ? 12 : 24} lg={projects.length > 3 ? 12 : 24}>
                                                        <div style={{
                                                            padding: '5px 10px',
                                                            border: '1px solid #e8e8e8',
                                                            borderRadius: '4px',
                                                            backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff'
                                                        }}>
                                                            <div className="d-flex justify-content-between items-center">
                                                                <span style={{ fontSize: '14px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                    <strong>{project.name}</strong>
                                                                    {project.description && (
                                                                        <span style={{ color: '#666', fontSize: '12px', marginTop: '2px' }}>
                                                                            | {project.description}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                                <span style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                }}>
                                                                    <Button
                                                                        type="text"
                                                                        size="small"
                                                                        icon={<Edit style={{ fontSize: '14px' }} />}
                                                                        onClick={() => setEditProject(project)}
                                                                        style={{ color: '#1890ff', padding: '0 4px' }}
                                                                    />
                                                                    <Button
                                                                        type="text"
                                                                        size="small"
                                                                        icon={<DeleteOutlined style={{ fontSize: '14px' }} />}
                                                                        onClick={(value) => {
                                                                            setConfirmationModal({
                                                                                message: `Delete Project?`,
                                                                                action: API_SERVICE.deleteProject,
                                                                                params: [details.id, project.id],
                                                                                type: 'deleteProject',
                                                                            });
                                                                        }}
                                                                        style={{ color: '#ff4d4f', padding: '0 4px' }}
                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    )}
                                </Box>
                                {addNew && (
                                    <ProjectCreateOrEditPage
                                        claimId={details.id}
                                        onClose={(e: boolean) => {
                                            if (e) {
                                                getProjects();
                                                if (projects.length === 0) {
                                                    refresh();
                                                }
                                            }
                                            setAddNew(false);
                                        }}
                                    />
                                )}

                                {editProject && (
                                    <ProjectCreateOrEditPage
                                        claimId={details.id}
                                        details={editProject}
                                        onClose={(e: boolean) => {
                                            if (e) {
                                                getProjects();
                                                refresh();
                                            }
                                            setEditProject(null);
                                        }}
                                    />
                                )}
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} style={{
                                marginTop: '30px',
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <Button
                                    type={'primary'}
                                    shape="round"
                                    className="theme-button primary"
                                    icon={<DownloadOutlined />}
                                >
                                    Download Report (Financial & Technical)
                                </Button>
                            </Col>
                        </Row>

                        <Row
                            justify={'center'}
                            style={{ marginBottom: '60px' }}
                            className="financial-technical-row"
                        >
                            <AccessControl id={62}>
                                <Col aria-disabled xs={24} sm={24} md={12} lg={12}>
                                    <div className="text-center py-3"
                                        style={{
                                            cursor: details.isProjectLinked > 0 ? undefined : 'not-allowed',
                                            pointerEvents: details.isProjectLinked > 0 ? undefined : 'none'
                                        }}
                                    >
                                        <Button
                                            type={'primary'}
                                            shape="round"
                                            disabled={details.isProjectLinked === 0}
                                            className="black-button lg"
                                        >
                                            <Link
                                                to={`${FINANCIALS}/${details.id}`}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={pound}
                                                        alt="pound"
                                                    />
                                                    <div className="text-left">
                                                        <h2>Financial</h2>
                                                        <small>Add Data</small>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Button>
                                        <br />
                                        <br />

                                        <Button
                                            shape="round"
                                            className="black-button my-3"
                                            icon={<CheckOutlined />}
                                            disabled={details.isProjectLinked === 0}
                                        >
                                            <Link
                                                to={`${FINALIZEFINANCIAL}/${details.id}`}
                                            >
                                                Finalize Financials
                                            </Link>{' '}
                                        </Button>
                                        <br />
                                        <Button
                                            onClick={handleDownload}
                                            shape="round"
                                            className="black-button"
                                            icon={<DownloadOutlined />}
                                            disabled={details.isProjectLinked === 0 || financialDowloading}
                                            loading={financialDowloading}
                                        >
                                            Download Financial Report
                                        </Button>
                                    </div>
                                </Col>
                            </AccessControl>
                            <AccessControl id={92}>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <div className="text-center py-3">
                                        <Button
                                            type={'primary'}
                                            shape="round"
                                            className="black-button lg"
                                        >
                                            <Link
                                                to={`${TECHNICALS}/${details.id}`}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={pound}
                                                        alt="pound"
                                                    />
                                                    <div className="text-left">
                                                        <h2>Technical</h2>
                                                        <small>Add Data</small>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Button>
                                        <br />
                                        <br />
                                        <Popconfirm
                                            title="Are you sure to you want to Finalize Report"
                                            onConfirm={() =>
                                                finalizeTechnicalStage()
                                            }
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                type="link"
                                                shape="round"
                                                className="black-button my-3"
                                                icon={<CheckOutlined />}
                                            >
                                                Finalize Technical
                                            </Button>
                                        </Popconfirm>
                                        <br />
                                        <Button
                                        disabled={loadingDownload}
                                        loading={loadingDownload}
                                            onClick={
                                                handleDownloadTechnicalReport
                                            }
                                            shape="round"
                                            className="black-button"
                                            icon={<DownloadOutlined />}
                                        >
                                            Download Technical Report
                                        </Button>
                                    </div>
                                </Col>
                            </AccessControl>
                        </Row>
                    </Col>
                    {currentStage >= 3 && (
                        <Col xs={24} className="finalizeSubmitBtn ">
                            <Popconfirm
                                title="Are you sure to you want to Finalize Claim"
                                onConfirm={() => finalizeFinalStage()}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    type="link"
                                    shape="round"
                                    className="black-button"
                                    icon={
                                        <CheckOutlined className="check-icon " />
                                    }
                                >
                                    Finalize Claim
                                </Button>
                            </Popconfirm>
                        </Col>
                    )}
                </Row>
            </div>

            <ConfirmationModal
                {...confirmationModal}
                callback={(a: any) => {
                    setConfirmationModal({});
                    refresh();
                    getProjects();
                }}
            />
        </div>
    );
}
